<template>
    <div id="licence-pie-chart">

    </div>
</template>

<script>
import Highcharts from 'highcharts';

export default {
    name: 'LicencePieChart',
    props: {
        statistiques: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            series: []
        }
    },
    mounted() {
        this.buildSeries();
        this.buildChart();
    },
    methods: {
        buildSeries() {
            let percent_licence = this.statistiques.licencie / (this.statistiques.licencie + this.statistiques.non_licencie);
            percent_licence = percent_licence * 100;
            percent_licence = Number(percent_licence.toFixed(2));
            let percent_non_licence = this.statistiques.non_licencie / (this.statistiques.licencie + this.statistiques.non_licencie);
            percent_non_licence = percent_non_licence * 100;
            percent_non_licence = Number(percent_non_licence.toFixed(2));
            this.series = [
                {
                    name: 'Licencié (' + this.statistiques.licencie + ')',
                    y: percent_licence
                },
                {
                    name: 'Non licencié (' + this.statistiques.non_licencie + ')',
                    y: percent_non_licence
                }
            ];
        },
        buildChart() {
            Highcharts.chart('licence-pie-chart', {
                chart: {
                    type: 'pie',
                    zooming: {
                        type: 'xy'
                    },
                    panning: {
                        enabled: true,
                        type: 'xy'
                    },
                    panKey: 'shift'
                },
                title: {
                    text: 'Répartition par licence'
                },
                tooltip: {
                    valueSuffix: '%'
                },

                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '{point.name}: {point.percentage:.1f}%',
                            style: {
                                fontSize: '14px',
                                fontWeight: 'bold',
                                textOutline: '2px contrast',
                                color: '#ffffff'
                            },
                            connectorColor: 'transparent',
                            connectorWidth: 0,
                            distance: -60,
                            position: 'center'
                        }
                    }
                },
                series: [
                    {
                        name: 'Percentage',
                        colorByPoint: true,
                        data: this.series
                    }
                ]
            });
        }
    }
}

</script>

<style lang="scss" scoped></style>